/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IGynaecHistory } from 'app/shared/model/gynaec-history.model';
import { CycleStatus } from 'app/shared/model/enumerations/cycle-status.model';

export interface IMensesEvent {
  id?: string;
  estimatedStartDate?: number | null;
  actualStartDate?: number | null;
  estimatedEndDate?: number | null;
  actualEndDate?: number | null;
  status?: keyof typeof CycleStatus | null;
  comments?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  patient?: IGlucoUser | null;
  gynaecHistory?: IGynaecHistory | null;
}

export const defaultValue: Readonly<IMensesEvent> = {
  active: false,
  draft: false,
};
